export default __webpack_public_path__ + "static/media/timetable.07ecba9b.gif";